import React from "react";
import useFontCases from "../../../utils/hooks/useFontCases";
import Barcode from "react-barcode";
import QRCode from "react-qr-code";
import { clippingParents } from "@popperjs/core";

const FoldableCard = ({ data: printData }) => {
  const { getFontCase } = useFontCases();

  const { data } = printData; // Extract the "data" object from printData

  // Extract graded_values, center_stone, and side_stone from the "data" object
  const gradedValues = data?.graded_values;
  const centerStone = data?.center_stone;
  const sideStone = data?.side_stone;

  // Combine all values into a single array
  const fontCaseAllValues = [gradedValues, centerStone, sideStone]
    .filter(Boolean)
    .flat();

  const fontCases = fontCaseAllValues?.map((data) => data?.font_case);
  const fontCase = getFontCase(parseInt(fontCases));
  const renderText = (value) => {
    switch (fontCase) {
      case "Uppercase":
        return <span style={{ textTransform: "uppercase" }}>{value}</span>;
      case "Lowercase":
        return <span style={{ textTransform: "lowercase" }}>{value}</span>;
      case "Title_Case":
        return <span style={{ textTransform: "capitalize" }}>{value}</span>;
      case "Sentence_Case":
        const sentanceWords = value?.toLowerCase().split(" ");
        const sentenceCaseWords = sentanceWords.map(
          (word) => word?.charAt(0)?.toUpperCase() + word?.slice(1)
        );
        return sentenceCaseWords.join(" ");
      case "Camel_Case":
        const camelWords = value?.toLowerCase().split(" ");
        const camelCaseWords = camelWords.map((word, index) =>
          index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
        );
        return camelCaseWords.join("");
      default:
        return <span>{value}</span>;
    }
  };

  return (
    <div className="pdf-print-surface">
      <div>
        {/* <div>
          <table
            border={0}
            cellSpacing={0}
            role="presentation"
            cellPadding={0}
            style={{
              backgroundColor: "#ffffff",
              borderCollapse: "collapse",
              maxWidth: 321.26,
              minWidth: 321.26,
              width: 321.26,
              maxHeight: 453.54,
              minHeight: 453.54,
              height: 453.54,
              margin: "0 56px 0 auto",
              border: "1px solid #dfe3eb",
            }}
          >
            <tbody>
              <tr>
                <td style={{ width: 321.26, height: 453.54 }}>
                  {data?.front_image && (
                    <img
                      src={data?.front_image ?? ""}
                      width={321.26}
                      height={453.54}
                      alt="fold_card"
                    />
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          style={{ background: "black", margin:"5px"  }}
        ></div> */}




        {/* old code */}
        {/* start */}
        {/* <div style={{ margin: 10 }}>
          <table
            border={0}
            cellSpacing={0}
            role="presentation"
            cellPadding={0}
            style={{
              backgroundColor: "#ffffff",
              borderCollapse: "collapse",
              maxWidth: 642.52,
              minWidth: 642.52,
              width: 642.52,
              maxHeight: 453.54,
              minHeight: 453.54,
              height: 453.54,
              margin: "0 auto",
              border: "1px solid #dfe3eb",
              fontFamily: "Inter",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    width: 642.52,
                    height: 78,
                    padding: 0,
                    verticalAlign: "baseline",
                  }}
                >
                  <img
                    src={data?.front_top_image}
                    alt="fold_card"
                    width={643}
                    height={78}
                    style={{ width: 642.52, height: 78 }}
                  />
                </td>
              </tr>

              <tr>
                <td>
                  <table
                    border={0}
                    cellSpacing={0}
                    role="presentation"
                    cellPadding={0}
                    style={{
                      verticalAlign: "baseline",
                      width: "100%",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td
                          style={{
                            width: 321.26,
                            paddingLeft: 20,
                            paddingRight: 20,
                            verticalAlign: "baseline",
                            textAlign: "center",
                          }}
                        >
                          <table
                            border={0}
                            cellSpacing={0}
                            role="presentation"
                            cellPadding={0}
                            style={{
                              textAlign: "center",
                              width: "100%",
                            }}
                          >
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    paddingTop: 10,
                                    paddingBottom: 10,
                                    paddingLeft: 85,
                                    paddingRight: 85,
                                    background: "#E1E1E1",
                                    whiteSpace: "nowrap",
                                    fontSize: 12,
                                    fontWeight: "bold",
                                    textAlign: "center",
                                  }}
                                >
                                  GRADING REPORT
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    paddingLeft: 44.5,
                                    paddingRight: 44.5,
                                    paddingTop: 3,
                                  }}
                                >
                                  <table
                                    border={0}
                                    cellSpacing={0}
                                    role="presentation"
                                    cellPadding={0}
                                    style={{
                                      textAlign: "center",
                                      width: 192,
                                    }}
                                  >
                                    <tbody>
                                      {data?.data?.graded_values?.map(
                                        (val, index) => {
                                          return (
                                            <React.Fragment key={index}>
                                              <tr>
                                                <td
                                                  style={{
                                                    fontSize: 10,
                                                    fontWeight: "regular",
                                                    verticalAlign: "top",
                                                    textAlign: "left",
                                                    width: 80,
                                                    paddingTop: 12,
                                                  }}
                                                >
                                                  {val?.bold === 1 ? (
                                                    <b>
                                                      {renderText(val?.text)}
                                                    </b>
                                                  ) : (
                                                    renderText(val?.text)
                                                  )}
                                                </td>
                                                <td
                                                  style={{
                                                    fontSize: 10,
                                                    fontWeight: "regular",
                                                    verticalAlign: "top",
                                                    textAlign: "center",
                                                    paddingLeft: 20,
                                                    paddingRight: 20,
                                                    paddingTop: 12,
                                                  }}
                                                >
                                                  :
                                                </td>
                                                <td
                                                  style={{
                                                    fontSize: 10,
                                                    fontWeight: "regular",
                                                    verticalAlign: "top",
                                                    textAlign: "left",
                                                    paddingTop: 12,
                                                  }}
                                                >
                                                  {val?.bold === 1 ? (
                                                    <b>
                                                      {renderText(val?.value)}
                                                    </b>
                                                  ) : (
                                                    renderText(val?.value)
                                                  )}
                                                </td>
                                              </tr>
                                            </React.Fragment>
                                          );
                                        }
                                      )}
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td
                          style={{
                            width: 321.26,
                            borderLeft: "1px solid #DADADA",
                          }}
                        >
                          <table
                            border={0}
                            cellSpacing={0}
                            role="presentation"
                            cellPadding={0}
                            style={{ width: "100%" }}
                          >
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    textAlign: "right",
                                    paddingRight: 47.11,
                                    paddingTop: 57.41,
                                  }}
                                >
                                  {data?.image && (
                                    <img
                                      src={data?.image ?? ""}
                                      width={226.77}
                                      height={151.18}
                                      alt=""
                                    />
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    paddingRight: 47.52,
                                    paddingTop: 53.41,
                                    textAlign: "right",
                                  }}
                                >
                                  {data?.qr && (
                                    <QRCode
                                      value={data?.qr ?? ""}
                                      width={60}
                                      height={60}
                                      style={{
                                        width: 60,
                                        height: 60,
                                      }}
                                    />
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td style={{ verticalAlign: "bottom" }}>
                  {parseInt(data?.footer_type) !== 2 ? (
                    <>
                      {data?.certificate_number && (
                        <div
                          style={{
                            textAlign: "center",
                            backgroundColor: "#ffffff",
                            lineHeight: 0,
                          }}
                        >
                          <Barcode
                            value={data?.certificate_number}
                            height={16}
                            width={0.5}
                            displayValue={false}
                            margin={0}
                          />
                        </div>
                      )}
                    </>
                  ) : (
                    <img
                      src={
                        data?.footer_type !== 2 && data?.front_foot_image
                          ? data?.front_foot_image
                          : ""
                      }
                      alt="footer"
                      width={642.52}
                      height={56.81}
                    />
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div> */}
{/* end */}


   <div className="pdf-print-surface" id="element-to-print"
            style={{
              width:"100%", 
              maxWidth:"645px",
              overflowY:"hidden", 
              overflowX:"auto", 
              margin:"10px auto",
              backgroundColor:"#fffff",
              margin: "0  auto",
              fontFamily: "'Graphik',san-serif",
             }}>
            {/* <div style={{ width:"100%", maxWidth:642.52, maxHeight:453.54, minHeight:453.54, height:453.54}}>
              <table border={0} cellSpacing={0} cellPadding={0}>
                <tr>
                  <td>
                    <table
                        border={0}
                        cellSpacing={0}
                        role="presentation"
                        cellPadding={0}
                        style={{
                          backgroundColor: "#ffffff",
                          borderCollapse: "collapse",
                          maxWidth: 321.26,
                          minWidth: 321.26,
                          width: 321.26,
                          maxHeight: 453.54,
                          minHeight: 453.54,
                          height: 453.54,
                          border: "1px solid #dfe3eb",
                        }}
                      >
                        <tbody>
                          <tr>
                            <td style={{ width: 321.26, height: 453.54 }}>
                              {data?.back_image && (
                                <img
                                  src={data?.back_image ?? ""}
                                  width={321.26}
                                  height={453.54}
                                  alt="fold_card"
                                />
                              )}
                            </td>
                          
                          </tr>
                        </tbody>
                    </table>
                  </td>
                  <td>
                    <table
                        border={0}
                        cellSpacing={0}
                        role="presentation"
                        cellPadding={0}
                        style={{
                          backgroundColor: "#ffffff",
                          borderCollapse: "collapse",
                          maxWidth: 321.26,
                          minWidth: 321.26,
                          width: 321.26,
                          maxHeight: 453.54,
                          minHeight: 453.54,
                          height: 453.54,
                          margin: "0 56px 0 auto",
                          border: "1px solid #dfe3eb",
                          borderLeft: "none",
                        }}
                      >
                        <tbody>
                          <tr>
                            <td style={{ width: 321.26, height: 453.54, position:"relative" }}>
                              <>
                                {data?.front_image && (
                                  <img
                                    src={data?.front_image ?? ""}
                                    width={321.26}
                                    height={453.54}
                                    alt="fold_card"
                                  />
                                )}

                                {data?.certificate_number && (
                                  <div
                                    style={{
                                      textAlign: "center",
                                      position: "absolute",
                                      top: "52%",
                                      left: "50%",
                                      transform: "translate(-50%, -50%)",
                                      lineHeight: 0,
                                    }}
                                  >
                                    <div 
                                      style={{
                                        fontSize: 15,
                                        fontWeight: 600,
                                        textAlign: "center",
                                        textTransform: "uppercase",
                                        width: "100%",
                                        marginBottom: 50,
                                        whiteSpace: "nowrap",
                                      }}>
                                        Summary No. : {data?.certificate_number}
                                      </div>

                                      {data?.qr && (
                                        <QRCode
                                          value={data?.qr ?? ""}
                                          width={60}
                                          height={60}
                                          style={{
                                            width: 60,
                                            height: 60,
                                          }}
                                        />
                                      )}
                                  </div>
                                )}
                              </>
                            </td>
                          </tr>
                        </tbody>
                    </table>
                  </td>
                </tr>
              </table>
            </div> */}
            <div style={{  
              
              // width:"100%", 
              width:642.52,
              maxWidth: 642.52,
              minWidth: 642.52,
              maxHeight: 453.54,
              minHeight: 453.54,
              height: 453.54,
              position:"relative",
              }}>
                <img
                  src={data.background_image}
                  style={{
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    objectFit: "contain", // or fill / contain
                    zIndex: -1,
                  }}
                />
              <table
                border={0}
                cellSpacing={0}
                role="presentation"
                cellPadding={0}
                style={{
                  // backgroundImage: `url(${data?.background_image})`,
                  // backgroundSize: "642.52px 453.54px",
                  // backgroundColor: "#ffffff",
                  // backgroundPosition: "center right",
                  // backgroundRepeat: "no-repeat",
                  borderCollapse: "collapse",
                  maxWidth: 642.52,
                  minWidth: 642.52,
                  width: 642.52,
                  maxHeight: 453.54,
                  minHeight: 453.54,
                  height: 453.54,
                  margin: "0 auto",
                  verticalAlign: "top",
                  border: "1px solid #dfe3eb",
                  fontFamily: "'Graphik',san-serif",
                }}
              >
                <tbody>

                  <tr>
                    <td
                      style={{
                        width: 321.26,
                        height: 78,
                        padding: 0,
                        verticalAlign: "baseline",
                        position:"relative"
                      }}
                    >
                      
                      <img
                        src={data?.front_top_image}
                        alt="fold_card"
                        width={642.52}
                        height={78}
                        style={{ width: 642.52, height: 78 }}
                      />
                      
                      
                    </td>
                  </tr>

                  <tr>
                    <td valign="top" style={{ verticalAlign: "top", }}>
                      <table
                        border={0}
                        cellSpacing={0}
                        role="presentation"
                        cellPadding={0}
                        style={{
                         verticalAlign: "top",
                          width: "100%",
                        }}
                      >
                        <tbody>
                          <tr>
                            <td
                            valign="top"
                              style={{
                                width: 321.26,
                                paddingLeft: 20,
                                paddingRight: 20,
                                verticalAlign: "top",
                                textAlign: "center",
                                marginBottom:5,
                              }}
                            >
                              <table
                                border={0}
                                cellSpacing={0}
                                role="presentation"
                                cellPadding={0}
                                style={{
                                  textAlign: "center",
                                  width: "100%",
                                  verticalAlign: "top",
                                }}
                              >
                                <tbody>

                                  <tr>
                                    <td
                                      style={{
                                        paddingTop: 8,
                                        paddingBottom: 4,
                                        // paddingLeft: 85,
                                        // paddingRight: 85,
                                        // background: "#E1E1E1",
                                        verticalAlign: "top",
                                        whiteSpace: "nowrap",
                                        fontSize: 12,
                                        fontWeight: "bold",
                                        textAlign: "center",
                                        verticalAlign: "top",
                                      }}
                                    >
                                      GRADING REPORT
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      valign="top"
                                      style={{
                                        paddingLeft: 20,
                                        paddingRight: 20,
                                        paddingTop: 10,
                                        paddingBottom: 5,
                                        backgroundColor:"#fff",
                                        border: "2px solid #E1E1E1",
                                        marginBottom:15,
                                        verticalAlign: "top",
                                        minHeight :265,
                                        width: "100%",
                                      }}
                                    >
                                      <table
                                        border={0}
                                        cellSpacing={0}
                                        role="presentation"
                                        cellPadding={0}
                                        style={{
                                          backgroundColor:"#fff",
                                          textAlign: "center",
                                          width: "100%",
                                          height: "auto",
                                          fontFamily: "'Graphik',san-serif",
                                          verticalAlign: "top",
                                          // overflowY: data?.data?.graded_values?.length * 24 > 264.57 ? "scroll" : "visible",
                                          // maxHeight: data?.data?.graded_values?.length * 24 > 264.57 ? 264.57 : "auto",
                                          minHeight :250,
                                          maxHeight :264.57 
                                        }}
                                      >
                                        <tbody >
                                          <tr>
                                             
                                            <td valign="middle"
                                            style={{
                                              fontSize: 12,
                                              fontWeight: 600,
                                              verticalAlign: "middle",
                                              textAlign: "left",
                                              width:92,
                                              paddingTop: 8,
                                              textTransform: "uppercase",
                                            }}>
                                              Summary No.
                                            </td>

                                            <td valign="middle" 
                                            style={{
                                              fontSize: 10,
                                              fontWeight: 500,
                                              verticalAlign: "middle",
                                              textAlign: "center",
                                              paddingLeft: 8,
                                              paddingRight: 8,
                                              paddingTop: 8,
                                            }}>:</td>
                                            <td valign="middle"
                                            style={{
                                              fontSize: 12,
                                              fontWeight: 600,
                                              verticalAlign: "middle",
                                              textAlign: "left",
                                              paddingTop: 10,
                                              textTransform: "uppercase",
                                            }}
                                            >
                                              {data?.certificate_number}
                                              
                                            </td>
                                          </tr>
                                          {data?.data?.graded_values?.map(
                                            (val, index) => {
                                              const fontCaseKey = getFontCase(
                                                parseInt(
                                                  val?.key_font_case
                                                )
                                              );

                                              const fontCaseValue = getFontCase(
                                                parseInt(
                                                  val?.value_font_case
                                                )
                                              );

                                              const renderText = (
                                                graded_value,
                                                key
                                              ) => {
                                                switch (
                                                  key === 1
                                                    ? fontCaseKey
                                                    : fontCaseValue
                                                ) {
                                                  case "Uppercase":
                                                    return (
                                                      <span
                                                        style={{
                                                          textTransform:
                                                            "uppercase",
                                                        }}
                                                      >
                                                        {graded_value}
                                                      </span>
                                                    );
                                                  case "Lowercase":
                                                    return (
                                                      <span
                                                        style={{
                                                          textTransform:
                                                            "lowercase",
                                                        }}
                                                      >
                                                        {graded_value}
                                                      </span>
                                                    );
                                                  case "Title_Case":
                                                    return (
                                                      <span
                                                        style={{
                                                          textTransform:
                                                            "capitalize",
                                                        }}
                                                      >
                                                        {graded_value}
                                                      </span>
                                                    );
                                                  case "Sentence_Case":
                                                    const sentanceWords =
                                                      graded_value
                                                        .toLowerCase()
                                                        .split(" ");
                                                    const sentenceCaseWords =
                                                      sentanceWords.map(
                                                        (word) =>
                                                          word
                                                            .charAt(0)
                                                            .toUpperCase() +
                                                          word.slice(1)
                                                      );
                                                    return sentenceCaseWords.join(
                                                      " "
                                                    );
                                                  case "Camel_Case":
                                                    const camelWords =
                                                      graded_value
                                                        .toLowerCase()
                                                        .split(" ");
                                                    const camelCaseWords =
                                                      camelWords.map(
                                                        (word, index) =>
                                                          index === 0
                                                            ? word
                                                            : word
                                                                .charAt(0)
                                                                .toUpperCase() +
                                                              word.slice(1)
                                                      );
                                                    return camelCaseWords.join(
                                                      ""
                                                    );
                                                  default:
                                                    return (
                                                      <span>
                                                        {graded_value}
                                                      </span>
                                                    );
                                                }
                                              };
                                              return (
                                                <React.Fragment key={index}>
                                                  <tr>
                                                    <td
                                                      style={{
                                                        fontSize: 10,
                                                        fontWeight: "regular",
                                                        verticalAlign: "top",
                                                        textAlign: "left",
                                                        width: 92,
                                                        paddingTop:2,
                                                        // background: "blue"
                                                      }}
                                                    >
                                                      {val?.bold === 1 ? (
                                                        <b>
                                                          {renderText(
                                                            val?.text,1
                                                          )}
                                                        </b>
                                                      ) : (
                                                        renderText(val?.text,1)
                                                      )}
                                                    </td>
                                                    <td
                                                      style={{
                                                        fontSize: 10,
                                                        fontWeight: "regular",
                                                        verticalAlign: "top",
                                                        textAlign: "center",
                                                        paddingLeft: 8,
                                                        paddingRight: 8,
                                                        paddingTop: 2,
                                                        // background: "green"
                                                      }}
                                                    >
                                                      :
                                                    </td>
                                                    <td
                                                      style={{
                                                        fontSize: 10,
                                                        fontWeight: "regular",
                                                        verticalAlign: "top",
                                                        textAlign: "left",
                                                        paddingTop: 2,
                                                        // background: "red",
                                                        
                                                      }}
                                                    >
                                                      {val?.bold === 1 ? (
                                                        <b>
                                                          {renderText(
                                                            val?.value,2
                                                          )}
                                                        </b>
                                                      ) : (
                                                        renderText(val?.value,2)
                                                      )}
                                                    </td>
                                                  </tr>
                                                </React.Fragment>
                                              );
                                            }
                                          )}
                                          <tr>
                                            <td colSpan={3} style={{paddingTop: 12, textAlign:"center", height: 16 }}>
                                                <>
                                                  {data?.certificate_number && (
                                                    <div
                                                      style={{
                                                        textAlign: "center",
                                                        backgroundColor: "#ffffff",
                                                        lineHeight: 0,
                                                      }}
                                                    >
                                                      <Barcode
                                                        value={data?.certificate_number}
                                                        height={16}
                                                        width={1}
                                                        displayValue={false}
                                                        margin={0}
                                                      />
                                                    </div>
                                                  )}
                                                </>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                            <td
                              style={{
                                width: 321.26,
                                borderLeft: "1px solid #DADADA",
                                 verticalAlign: "top",
                                // background: "red"
                              }}
                            >
                              <table
                                border={0}
                                cellSpacing={0}
                                role="presentation"
                                cellPadding={0}
                                style={{ width: "100%", verticalAlign: "top", }}
                                
                              >
                                <tbody>
                                  <tr>
                                    <td
                                      style={{
                                        textAlign: "center",
                                        paddingLeft: 30,
                                        paddingRight: 30,
                                        paddingTop: 35,
                                        paddingBottom:20,
                                        width: "100%",
                                       
                                        // background: "green"
                                      }}
                                    >
                                      
                                      
                                      {data?.image && (
                                        <img
                                          src={data?.image ?? ""}
                                          width={226.77}
                                          height={151.18}
                                          alt="Product Image"
                                         style={{
                                          maxHeight:151.18,
                                          maxWidth:226.77,
                                          objectFit: "cover",
                                          display:"block",
                                          margin: "0 auto",
                                          borderRadius:6,
                                          overflow:"hidden",
                                          }}
                                        />
                                      )}
                                    </td>
                                  </tr>
                                  {/* <tr>
                                    <td
                                      style={{
                                        paddingRight: 47.52,
                                        paddingTop: 53.41,
                                        textAlign: "right",
                                      }}
                                    >
                                      {data?.qr && (
                                        <QRCode
                                          value={data?.qr ?? ""}
                                          width={60}
                                          height={60}
                                          style={{
                                            width: 60,
                                            height: 60,
                                          }}
                                        />
                                      )}
                                    </td>
                                  </tr> */}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ verticalAlign: "bottom" }}>
                      {/* {parseInt(data?.footer_type) !== 2 ? ( */}
                        {/* <>
                          {data?.certificate_number && (
                            <div
                              style={{
                                textAlign: "center",
                                backgroundColor: "#ffffff",
                                lineHeight: 0,
                              }}
                            >
                              <Barcode
                                value={data?.certificate_number}
                                height={16}
                                width={0.5}
                                displayValue={false}
                                margin={0}
                              />
                            </div>
                          )}
                        </> */}
                      {/* ) : ( */}
                        <img
                          src={
                            // data?.footer_type !== 2 && data?.front_foot_image
                            //   ?
                               data?.front_foot_image
                              // : ""
                          }
                          alt="footer"
                          width={642.52}
                          height={56.81}
                        />
                      {/* )} */}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              style={{ background: "black" }}
              className="html2pdf__page-break"
            ></div>
          </div>




        {/* <div
          style={{ background: "black" }}
          className="html2pdf__page-break"
        ></div> */}
      </div>
    </div>
  );
};

export default FoldableCard;
